import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1afac318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container margin-left" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-8" }
const _hoisted_4 = { class: "row text-start fs-4" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row mt-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Booked By:", -1))
const _hoisted_8 = { class: "col-8 text-start" }
const _hoisted_9 = { class: "row mt-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "For:", -1))
const _hoisted_11 = { class: "col-8 text-start" }
const _hoisted_12 = { class: "row mt-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Branch:", -1))
const _hoisted_14 = { class: "col-8 text-start" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "row mt-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Order Item Type:", -1))
const _hoisted_19 = { class: "col-8 text-start" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  selected: ""
}, "choose", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "row mt-1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Free text type:", -1))
const _hoisted_24 = { class: "col-8 text-start" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "row mt-1"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Media:", -1))
const _hoisted_29 = { class: "col-8 text-start" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 2,
  class: "row mt-1"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Print Size:", -1))
const _hoisted_34 = { class: "col-8 text-start" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 3,
  class: "row mt-1"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Borders:", -1))
const _hoisted_39 = { class: "col-8 text-start" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Top (mm):", -1))
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Right (mm):", -1))
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bottom (mm):", -1))
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Left (mm):", -1))
const _hoisted_49 = {
  key: 4,
  class: "row mt-1"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Frame Type:", -1))
const _hoisted_51 = { class: "col-8 text-start" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 5,
  class: "row mt-1"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Moulding:", -1))
const _hoisted_56 = { class: "col-8 text-start" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 6,
  class: "row mt-1"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Moulding Size:", -1))
const _hoisted_61 = { class: "col-8 text-start" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_63 = ["value"]
const _hoisted_64 = {
  key: 7,
  class: "row mt-1"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Glass:", -1))
const _hoisted_66 = { class: "col-8 text-start" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = {
  key: 8,
  class: "row mt-1"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Window Mount:", -1))
const _hoisted_71 = { class: "col-8 text-start" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_73 = ["value"]
const _hoisted_74 = {
  key: 9,
  class: "row mt-1"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Borders:", -1))
const _hoisted_76 = { class: "col-8 text-start" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-6" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Top (mm):", -1))
const _hoisted_80 = { class: "col-6" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Right (mm):", -1))
const _hoisted_82 = { class: "col-6" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bottom (mm):", -1))
const _hoisted_84 = { class: "col-6" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Left (mm):", -1))
const _hoisted_86 = {
  key: 10,
  class: "row mt-1"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Substrates:", -1))
const _hoisted_88 = { class: "col-8 text-start" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_90 = ["value"]
const _hoisted_91 = {
  key: 11,
  class: "row mt-1"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Substrate Size:", -1))
const _hoisted_93 = { class: "col-8 text-start" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_95 = ["value"]
const _hoisted_96 = {
  key: 12,
  class: "row mt-1"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Fixing:", -1))
const _hoisted_98 = { class: "col-8 text-start" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_100 = ["value"]
const _hoisted_101 = {
  key: 13,
  class: "row mt-1"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Backing:", -1))
const _hoisted_103 = { class: "col-8 text-start" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_105 = ["value"]
const _hoisted_106 = {
  key: 14,
  class: "row mt-1"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Colour:", -1))
const _hoisted_108 = { class: "col-8 text-start" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_110 = ["value"]
const _hoisted_111 = {
  key: 15,
  class: "row mt-1"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Lamination:", -1))
const _hoisted_113 = { class: "col-8 text-start" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_115 = ["value"]
const _hoisted_116 = {
  key: 16,
  class: "row mt-1"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Stationery:", -1))
const _hoisted_118 = { class: "col-8 text-start" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_120 = ["value"]
const _hoisted_121 = {
  key: 17,
  class: "row mt-1"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Booth and Retouch:", -1))
const _hoisted_123 = { class: "col-8 text-start" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_125 = ["value"]
const _hoisted_126 = { class: "row mt-1" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Address:", -1))
const _hoisted_128 = { class: "col-8 text-start" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Collect In Studio", -1))
const _hoisted_130 = ["value"]
const _hoisted_131 = {
  key: 18,
  class: "row mt-1"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Type:", -1))
const _hoisted_133 = { class: "col-8 text-start" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "choose", -1))
const _hoisted_135 = ["value"]
const _hoisted_136 = {
  key: 19,
  class: "row mt-1"
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Free text:", -1))
const _hoisted_138 = { class: "col-8 text-start" }
const _hoisted_139 = {
  key: 20,
  class: "row mt-1"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Quantity:", -1))
const _hoisted_141 = { class: "col-8 text-start" }
const _hoisted_142 = ["value"]
const _hoisted_143 = { class: "row mt-1" }
const _hoisted_144 = { class: "col-4 text-end fw-bold" }
const _hoisted_145 = { class: "col-8 text-start" }
const _hoisted_146 = { class: "row mt-1" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Discount Percentage, %:", -1))
const _hoisted_148 = { class: "col-8 text-start" }
const _hoisted_149 = {
  key: 21,
  class: "row mt-1"
}
const _hoisted_150 = { class: "col-4 text-end fw-bold" }
const _hoisted_151 = { class: "col-8 text-start" }
const _hoisted_152 = { class: "row mt-1" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "VAT:", -1))
const _hoisted_154 = { class: "col-8 text-start" }
const _hoisted_155 = { class: "row mt-1" }
const _hoisted_156 = { class: "col-4 text-end fw-bold" }
const _hoisted_157 = { class: "col-8 text-start" }
const _hoisted_158 = { class: "row mt-1" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, null, -1))
const _hoisted_160 = { class: "col-8 text-start" }
const _hoisted_161 = ["disabled"]
const _hoisted_162 = {
  key: 0,
  class: "special-order-table-container"
}
const _hoisted_163 = { class: "table table-striped table-bordered table-hover special-order-table" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Order Item Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Price Exc. VAT"),
    /*#__PURE__*/_createElementVNode("th", null, "Discount %"),
    /*#__PURE__*/_createElementVNode("th", null, "Price After Discount"),
    /*#__PURE__*/_createElementVNode("th", null, "Price Inc. Vat"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_165 = { key: 0 }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Size"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Borders (top/right/bottom/left): ")
], -1))
const _hoisted_170 = { key: 1 }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Size"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Type"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Moulding"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_176 = { key: 0 }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Glass"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_179 = { key: 1 }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Window Mount"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Borders (top/right/bottom/left): ")
], -1))
const _hoisted_184 = { key: 2 }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Size"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Substrate"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_188 = { key: 0 }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Lamination"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_191 = { key: 1 }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Backing"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Fixing"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Colour"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_199 = { key: 3 }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Type"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_202 = { key: 4 }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Type"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_205 = { key: 5 }
const _hoisted_206 = { key: 0 }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "To"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Type"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_210 = { key: 6 }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Description"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_212 = ["onClick"]
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "fw-bold"
}, "TOTAL", -1))
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_215 = { class: "m-1" }
const _hoisted_216 = { class: "special-order-table-ref" }
const _hoisted_217 = /*#__PURE__*/_createTextVNode(" Customer Ref (Optional) ")
const _hoisted_218 = { class: "special-order-table-quote" }
const _hoisted_219 = { colspan: "4" }
const _hoisted_220 = { class: "special-order-table-email" }
const _hoisted_221 = { class: "row special-order-table-form" }
const _hoisted_222 = { class: "row mt-1" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "New Status:", -1))
const _hoisted_224 = { class: "col-8 text-start" }
const _hoisted_225 = ["value"]
const _hoisted_226 = { class: "row mt-1" }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold d-flex justify-content-end align-items-center" }, "Due Date:", -1))
const _hoisted_228 = { class: "col-8 text-start" }
const _hoisted_229 = { class: "row mt-1" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Message to lab:", -1))
const _hoisted_231 = { class: "col-8 text-start" }
const _hoisted_232 = { class: "row mt-1" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_234 = { class: "col-8 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_PreventUnpaidStatusSelectModalVue = _resolveComponent("PreventUnpaidStatusSelectModalVue")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_PreventUnpaidStatusSelectModalVue, {
        show: _ctx.showPreventUnpdaidStatusSelectModal,
        "allows-invoicing": _ctx.userIsForInvoicing,
        users: _ctx.modalSelectList,
        "is-saving": _ctx.preventUnpdaidStatusSelectModalIsSaving,
        onClose: _ctx.onClosePreventUnpaidModal
      }, null, 8, ["show", "allows-invoicing", "users", "is-saving", "onClose"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, " Edit In-House Order " + _toDisplayString(_ctx.specialOrderInEdit), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.customerEmail), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_ctx.specialOrder.UserFullName) + " (" + _toDisplayString(_ctx.customerId) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.specialOrder.DeliveryBranchId) = $event)),
                class: "form-select",
                disabled: 
                _ctx.specialOrder.SelectedShippingAddress !== null ||
                _ctx.specialOrder.Id !== 0
              ,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDeliveryBranch()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryBranches, (branch) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: branch.Id,
                    value: branch.Id
                  }, _toDisplayString(branch.Name), 9, _hoisted_16))
                }), 128))
              ], 40, _hoisted_15), [
                [_vModelSelect, _ctx.specialOrder.DeliveryBranchId]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentSpecialOrderItem.OrderTypeId) = $event)),
                class: "form-select",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOrderItemTypeChanged()))
              }, [
                _hoisted_20,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemTypes, (itemType) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: itemType.name,
                    value: itemType.value
                  }, _toDisplayString(itemType.name), 9, _hoisted_21))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.currentSpecialOrderItem.OrderTypeId]
              ])
            ])
          ]),
          (_ctx.currentSpecialOrderItem.OrderTypeId === 7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentSpecialOrderItem.OrderFreeTextTypeId) = $event)),
                    class: "form-select",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onOrderItemFreeTextTypeChanged()))
                  }, [
                    _hoisted_25,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemFreeTextTypes, (itemType) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: itemType.name,
                        value: itemType.value
                      }, _toDisplayString(itemType.name), 9, _hoisted_26))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.OrderFreeTextTypeId]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 1 && _ctx.printMedias.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentSpecialOrderItem.PrintMedia) = $event)),
                    class: "form-select",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onPrintMediaChange()))
                  }, [
                    _hoisted_30,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printMedias, (printMedia) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: printMedia.EntityId,
                        value: printMedia
                      }, _toDisplayString(printMedia.Name), 9, _hoisted_31))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.PrintMedia]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 1 &&
            _ctx.currentSpecialOrderItem.PrintMedia &&
            _ctx.printSizes.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentSpecialOrderItem.Size) = $event)),
                    class: "form-select",
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onPrintingSizeChanged()))
                  }, [
                    _hoisted_35,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printSizes, (printSize) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: printSize.EntityId,
                        value: printSize
                      }, _toDisplayString(printSize.Name), 9, _hoisted_36))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Size]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 1 &&
            _ctx.currentSpecialOrderItem.Size
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentSpecialOrderItem.BorderTopMm) = $event)),
                        type: "text",
                        class: "form-control",
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.specialOrderBorderTopChanged()))
                      }, null, 544), [
                        [_vModelText, _ctx.currentSpecialOrderItem.BorderTopMm]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentSpecialOrderItem.BorderRightMm) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.currentSpecialOrderItem.BorderRightMm]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentSpecialOrderItem.BorderBottomMm) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.currentSpecialOrderItem.BorderBottomMm]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.currentSpecialOrderItem.BorderLeftMm) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.currentSpecialOrderItem.BorderLeftMm]
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSpecialOrderItem.OrderTypeId === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.currentSpecialOrderItem.Frame) = $event)),
                    class: "form-select",
                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onFrameTypeChange()))
                  }, [
                    _hoisted_52,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printFrameTypes, (printFrameType) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: printFrameType.Id,
                        value: printFrameType
                      }, _toDisplayString(printFrameType.Name), 9, _hoisted_53))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Frame]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 2 &&
            _ctx.currentSpecialOrderItem.Frame !== null
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentSpecialOrderItem.Moulding) = $event)),
                    class: "form-select",
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onMouldingChange()))
                  }, [
                    _hoisted_57,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouldings, (moulding) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: moulding.Id,
                        value: moulding
                      }, _toDisplayString(moulding.Description), 9, _hoisted_58))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Moulding]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 2 &&
            _ctx.currentSpecialOrderItem.Moulding !== null
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.currentSpecialOrderItem.Size) = $event)),
                    class: "form-select",
                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onMouldingSizeChange()))
                  }, [
                    _hoisted_62,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printSizes, (printSize) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: printSize.EntityId,
                        value: printSize
                      }, _toDisplayString(printSize.Name), 9, _hoisted_63))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Size]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 2 &&
            _ctx.currentSpecialOrderItem.Size !== null
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentSpecialOrderItem.Glass) = $event)),
                    class: "form-select",
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onGlassChanged()))
                  }, [
                    _hoisted_67,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.glasses, (glass) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: glass.EntityId,
                        value: glass
                      }, _toDisplayString(glass.Name), 9, _hoisted_68))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Glass]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 2 &&
            _ctx.currentSpecialOrderItem.Size !== null
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.currentSpecialOrderItem.WindowMount) = $event)),
                    class: "form-select",
                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onMountChanged()))
                  }, [
                    _hoisted_72,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windowMounts, (windowMount) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: windowMount.EntityId,
                        value: windowMount
                      }, _toDisplayString(windowMount.Name), 9, _hoisted_73))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.WindowMount]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSpecialOrderItem.WindowMount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.currentSpecialOrderItem.WmBorderTopMm) = $event)),
                        type: "text",
                        class: "form-control",
                        onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.specialOrderWmBorderTopChanged()))
                      }, null, 544), [
                        [_vModelText, _ctx.currentSpecialOrderItem.WmBorderTopMm]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.currentSpecialOrderItem.WmBorderRightMm) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.currentSpecialOrderItem.WmBorderRightMm]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.currentSpecialOrderItem.WmBorderBottomMm) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.currentSpecialOrderItem.WmBorderBottomMm]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.currentSpecialOrderItem.WmBorderLeftMm) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.currentSpecialOrderItem.WmBorderLeftMm]
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSpecialOrderItem.OrderTypeId === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.currentSpecialOrderItem.Substrate) = $event)),
                    class: "form-select",
                    onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onSubstrateChanged()))
                  }, [
                    _hoisted_89,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.substrates, (substrate) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: substrate.Id,
                        value: substrate
                      }, _toDisplayString(substrate.Name), 9, _hoisted_90))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Substrate]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 3 &&
            _ctx.currentSpecialOrderItem.Substrate != null
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                _hoisted_92,
                _createElementVNode("div", _hoisted_93, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.currentSpecialOrderItem.Size) = $event)),
                    class: "form-select",
                    onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onSubstrateSizeChanged()))
                  }, [
                    _hoisted_94,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printSizes, (printSize) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: printSize.EntityId,
                        value: printSize
                      }, _toDisplayString(printSize.Name), 9, _hoisted_95))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Size]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 3 &&
            _ctx.currentSpecialOrderItem.Size != null &&
            _ctx.currentSpecialOrderItem.Substrate != null &&
            _ctx.fixings.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                _hoisted_97,
                _createElementVNode("div", _hoisted_98, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.currentSpecialOrderItem.Fixing) = $event)),
                    class: "form-select",
                    onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onFixingChanged()))
                  }, [
                    _hoisted_99,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixings, (fixing) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: fixing.Id,
                        value: fixing
                      }, _toDisplayString(fixing.Name), 9, _hoisted_100))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Fixing]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 3 &&
            _ctx.currentSpecialOrderItem.Substrate != null &&
            _ctx.currentSpecialOrderItem.Substrate.SupportsBacking
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.currentSpecialOrderItem.Backing) = $event)),
                    class: "form-select"
                  }, [
                    _hoisted_104,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backings, (backing) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: backing.Id,
                        value: backing
                      }, _toDisplayString(backing.Name), 9, _hoisted_105))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Backing]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 3 &&
            _ctx.currentSpecialOrderItem.Size != null &&
            _ctx.currentSpecialOrderItem.Substrate != null &&
            _ctx.substrateColours.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                _hoisted_107,
                _createElementVNode("div", _hoisted_108, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.currentSpecialOrderItem.SubstrateColour) = $event)),
                    class: "form-select"
                  }, [
                    _hoisted_109,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.substrateColours, (substrateColour) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: substrateColour.Id,
                        value: substrateColour
                      }, _toDisplayString(substrateColour.Name), 9, _hoisted_110))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.SubstrateColour]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 3 &&
            _ctx.currentSpecialOrderItem.Size != null &&
            _ctx.currentSpecialOrderItem.Substrate != null &&
            _ctx.currentSpecialOrderItem.Substrate.SupportsLamination &&
            _ctx.laminations.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                _hoisted_112,
                _createElementVNode("div", _hoisted_113, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.currentSpecialOrderItem.Lamination) = $event)),
                    class: "form-select",
                    onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onLaminationChanged()))
                  }, [
                    _hoisted_114,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.laminations, (lamination) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: lamination.Id,
                        value: lamination
                      }, _toDisplayString(lamination.Name), 9, _hoisted_115))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Lamination]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 4 && _ctx.stationeries.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                _hoisted_117,
                _createElementVNode("div", _hoisted_118, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.currentSpecialOrderItem.Stationery) = $event)),
                    class: "form-select",
                    onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onStationeryChanged()))
                  }, [
                    _hoisted_119,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationeries, (stationery) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: stationery.Id,
                        value: stationery
                      }, _toDisplayString(stationery.Name), 9, _hoisted_120))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Stationery]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 5 && _ctx.retouchings.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                _hoisted_122,
                _createElementVNode("div", _hoisted_123, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.currentSpecialOrderItem.Retouching) = $event)),
                    class: "form-select",
                    onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onStationeryChanged()))
                  }, [
                    _hoisted_124,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retouchings, (retouch) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: retouch.Id,
                        value: retouch
                      }, _toDisplayString(retouch.Name), 9, _hoisted_125))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Retouching]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_126, [
            _hoisted_127,
            _createElementVNode("div", _hoisted_128, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.specialOrder.SelectedShippingAddress) = $event)),
                class: "form-select",
                onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onDeliveryAddressChanged()))
              }, [
                _hoisted_129,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialOrder.ShippingAddresses, (address) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: address.Id,
                    value: address
                  }, _toDisplayString(address.AddressOnOneLine), 9, _hoisted_130))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.specialOrder.SelectedShippingAddress]
              ])
            ])
          ]),
          (
            _ctx.currentSpecialOrderItem.OrderTypeId === 6 &&
            _ctx.specialOrder.DeliveryOptions.length > 0 &&
            _ctx.specialOrder.SelectedShippingAddress != null
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("div", _hoisted_133, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.specialOrder.DeliveryTypeTentative) = $event)),
                    class: "form-select",
                    onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onStationeryChanged()))
                  }, [
                    _hoisted_134,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialOrder.DeliveryOptions, (delivery) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: delivery.Id,
                        value: delivery
                      }, _toDisplayString(delivery.Name), 9, _hoisted_135))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.specialOrder.DeliveryTypeTentative]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSpecialOrderItem.OrderTypeId === 7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                _hoisted_137,
                _createElementVNode("div", _hoisted_138, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.currentSpecialOrderItem.Description) = $event)),
                    rows: "3",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.currentSpecialOrderItem.Description]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSpecialOrderItem.OrderTypeId != 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                _hoisted_140,
                _createElementVNode("div", _hoisted_141, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.currentSpecialOrderItem.Quantity) = $event)),
                    class: "form-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quantityArray, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item,
                        value: item
                      }, _toDisplayString(item), 9, _hoisted_142))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentSpecialOrderItem.Quantity]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, " Price Excluding VAT, " + _toDisplayString(_ctx.currency) + ": ", 1),
            _createElementVNode("div", _hoisted_145, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.currentSpecialOrderItem.PriceExcludingVat) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.currentSpecialOrderItem.PriceExcludingVat]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_146, [
            _hoisted_147,
            _createElementVNode("div", _hoisted_148, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.currentSpecialOrderItem.DiscountPercentage) = $event)),
                type: "text",
                class: "form-control",
                onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.calculateSpecialOrderPrice()))
              }, null, 544), [
                [_vModelText, _ctx.currentSpecialOrderItem.DiscountPercentage]
              ])
            ])
          ]),
          (parseFloat(_ctx.currentSpecialOrderItem.DiscountPercentage) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                _createElementVNode("div", _hoisted_150, " Price After Discount, " + _toDisplayString(_ctx.currency) + ": ", 1),
                _createElementVNode("div", _hoisted_151, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.priceAfterDiscount()), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_152, [
            _hoisted_153,
            _createElementVNode("div", _hoisted_154, [
              _createElementVNode("span", null, _toDisplayString(_ctx.specialOrder.VatRate) + " %", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_155, [
            _createElementVNode("div", _hoisted_156, " Price Including VAT, " + _toDisplayString(_ctx.currency) + ": ", 1),
            _createElementVNode("div", _hoisted_157, [
              _createElementVNode("span", null, _toDisplayString(_ctx.priceInVat()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_158, [
            _hoisted_159,
            _createElementVNode("div", _hoisted_160, [
              (!_ctx.isSubmitedOrder)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success",
                    disabled: !_ctx.canAddSpecialOrderItem,
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.addSpecialOrderItem()))
                  }, " Add Item ", 8, _hoisted_161))
                : _createCommentVNode("", true),
              (_ctx.isSubmitedOrder)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-warning",
                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onBackToCustomerOrders()))
                  }, " Back to Customer Orders "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.specialOrderItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
          _createElementVNode("table", _hoisted_163, [
            _hoisted_164,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSpecialOrderItemToShow, (specialOrderItem, specialOrderItemIndex) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: specialOrderItem.Id
                }, [
                  _createElementVNode("td", null, _toDisplayString(specialOrderItem.OrderTypeName), 1),
                  _createElementVNode("td", null, [
                    (specialOrderItem.OrderTypeId === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                          _hoisted_166,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Size?.Name), 1),
                          _hoisted_167,
                          _createElementVNode("span", null, [
                            _createElementVNode("em", null, _toDisplayString(specialOrderItem.PrintMedia?.Name), 1)
                          ]),
                          _hoisted_168,
                          _hoisted_169,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.BorderTopMm +
                  "mm/" +
                  specialOrderItem.BorderRightMm +
                  "mm/" +
                  specialOrderItem.BorderBottomMm +
                  "mm/" +
                  specialOrderItem.BorderLeftMm +
                  "mm"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (specialOrderItem.OrderTypeId === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                          _hoisted_171,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Size?.Name), 1),
                          _hoisted_172,
                          _hoisted_173,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Frame?.Name), 1),
                          _hoisted_174,
                          _hoisted_175,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Moulding?.Description), 1),
                          (specialOrderItem.Frame?.SupportsGlass)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_176, [
                                _hoisted_177,
                                _hoisted_178,
                                _createElementVNode("span", null, _toDisplayString(specialOrderItem.Glass?.Name ?? "N/A"), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (specialOrderItem.Frame?.SupportsWindowMount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_179, [
                                _hoisted_180,
                                _hoisted_181,
                                _createElementVNode("span", null, _toDisplayString(specialOrderItem.WindowMount?.Name ?? "N/A"), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_182,
                          _hoisted_183,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.WmBorderTopMm +
                  "mm/" +
                  specialOrderItem.WmBorderRightMm +
                  "mm/" +
                  specialOrderItem.WmBorderBottomMm +
                  "mm/" +
                  specialOrderItem.WmBorderLeftMm +
                  "mm"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (specialOrderItem.OrderTypeId === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                          _hoisted_185,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Size?.Name), 1),
                          _hoisted_186,
                          _hoisted_187,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Substrate?.Name), 1),
                          (specialOrderItem.Substrate?.SupportsLamination)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_188, [
                                _hoisted_189,
                                _hoisted_190,
                                _createElementVNode("span", null, _toDisplayString(specialOrderItem.Lamination?.Name ?? "N/A"), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (specialOrderItem.Substrate?.SupportsBacking)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_191, [
                                _hoisted_192,
                                _hoisted_193,
                                _createElementVNode("span", null, _toDisplayString(specialOrderItem.Backing?.Name ?? "N/A"), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_194,
                          _hoisted_195,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Fixing?.Name ?? "N/A"), 1),
                          _hoisted_196,
                          _hoisted_197,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.SubstrateColour?.Name ?? "N/A"), 1),
                          _hoisted_198
                        ]))
                      : _createCommentVNode("", true),
                    (specialOrderItem.OrderTypeId === 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                          _hoisted_200,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Stationery?.Name), 1),
                          _hoisted_201
                        ]))
                      : _createCommentVNode("", true),
                    (specialOrderItem.OrderTypeId === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                          _hoisted_203,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Retouching?.Name), 1),
                          _hoisted_204
                        ]))
                      : _createCommentVNode("", true),
                    (specialOrderItem.OrderTypeId === 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                          (
                  _ctx.specialOrder.DeliveryType && _ctx.specialOrder.DeliveryType.Id > 0
                )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_206, [
                                _hoisted_207,
                                _createElementVNode("span", null, _toDisplayString(_ctx.specialOrder.SelectedShippingAddress?.AddressOnOneLine ??
                  "Collect in Studio"), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_208,
                          _hoisted_209,
                          _createElementVNode("span", null, _toDisplayString(_ctx.specialOrder.DeliveryType?.Name ?? ""), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (specialOrderItem.OrderTypeId === 7)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                          _hoisted_211,
                          _createElementVNode("span", null, _toDisplayString(specialOrderItem.Description), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(specialOrderItem.Quantity), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.specialOrderItemExcVat(specialOrderItem)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.specialOrderItemDiscount(specialOrderItem)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.specialOrderItemPriceAfterDiscount(specialOrderItem)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.specialOrderItemPriceIncVat(specialOrderItem)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-warning",
                      onClick: ($event: any) => (_ctx.onRemoveSpecialItemClick(specialOrderItemIndex))
                    }, " Remove ", 8, _hoisted_212)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _hoisted_213,
                _createElementVNode("td", null, _toDisplayString(_ctx.getTotalQuantity), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.specialOrderTotalExcVat), 1),
                _hoisted_214,
                _createElementVNode("td", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.specialOrderTotalVatAfterDiscount), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.specialOrderTotalIncVat), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_215, [
                    (_ctx.showRemoveAll)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-warning",
                          onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.onRemoveAllClick()))
                        }, " REMOVE ALL "))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-success",
                          onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.onRemoveAllClick()))
                        }, " CANCEL REMOVAL "))
                  ]),
                  _createElementVNode("div", null, [
                    (!_ctx.showRemoveAll)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-danger m-1",
                          onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.onRemoveAllSpecialOrderItemsLeaveOrderClick()))
                        }, " REMOVE ALL BUT LEAVE ORDER "))
                      : _createCommentVNode("", true),
                    (!_ctx.showRemoveAll)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-danger m-1",
                          onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.onRemoveAllSpecialOrderItemsIncludingOrderClick()))
                        }, " REMOVE ALL INCLUDING ORDER "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_216, [
                  _hoisted_217,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.customerReference) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.customerReference]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_218, [
                    _createElementVNode("button", {
                      class: "btn btn-danger",
                      onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.onViewQuoteClick()))
                    }, " View Quote ")
                  ])
                ]),
                _createElementVNode("td", _hoisted_219, [
                  _createElementVNode("div", _hoisted_220, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "btn btn-danger",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onEmailQuoteClick()))
                      }, " Email Quote ")
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.emailQuoteTo) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.emailQuoteTo]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_221, [
                    _createElementVNode("div", _hoisted_222, [
                      _hoisted_223,
                      _createElementVNode("div", _hoisted_224, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.specialOrder.NewStatus) = $event)),
                          class: "form-select"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderStati, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.value,
                              value: item.value
                            }, _toDisplayString(item.name), 9, _hoisted_225))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.specialOrder.NewStatus]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_226, [
                      _hoisted_227,
                      _createElementVNode("div", _hoisted_228, [
                        _createVNode(_component_datepicker, {
                          modelValue: _ctx.dueDate,
                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.dueDate) = $event)),
                          style: { width: 'auto' }
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_229, [
                      _hoisted_230,
                      _createElementVNode("div", _hoisted_231, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.specialOrder.MessageToLab) = $event)),
                          class: "form-control",
                          cols: "3",
                          rows: "3"
                        }, null, 512), [
                          [_vModelText, _ctx.specialOrder.MessageToLab]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_232, [
                      _hoisted_233,
                      _createElementVNode("div", _hoisted_234, [
                        _createElementVNode("button", {
                          class: "btn btn-success",
                          onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.openPreventUnpaidModal()))
                        }, " Finalise In-House Order ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-warning",
                    onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.submitSpecialOrder(true, 0)))
                  }, " Save In-House Order ")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}